export default "__VITE_ASSET__bd167397__"